import { getPortalToken, getSelectedBusinessId } from '../app/businessContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4001/api';
export const PORTAL_SESSION_EXPIRED_EVENT = 'seaweeds:portal-session-expired';
export const PORTAL_SESSION_EXPIRED_MESSAGE =
  'Your e-Portal session expired. Please login again.';
const PORTAL_SESSION_INVALID_MESSAGE =
  'Your e-Portal session is invalid. Please login again.';
let hasInstalledSessionExpiredFetchWatcher = false;
let lastSessionExpiredNotificationAt = 0;

export function buildApiUrl(path) {
  return `${API_BASE_URL}${path}`;
}

export function buildAssetUrl(path) {
  const normalizedPath = String(path || '').trim();

  if (!normalizedPath) {
    return '';
  }

  if (/^https?:\/\//i.test(normalizedPath) || normalizedPath.startsWith('data:')) {
    return normalizedPath;
  }

  const apiUrl = new URL(API_BASE_URL);
  const assetPath = normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;

  return `${apiUrl.origin}${assetPath}`;
}

export function buildWebSocketUrl(path = '/ws') {
  const apiUrl = new URL(API_BASE_URL);
  const websocketProtocol = apiUrl.protocol === 'https:' ? 'wss:' : 'ws:';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${websocketProtocol}//${apiUrl.host}${normalizedPath}`;
}

export function withBusinessHeaders(headers = {}) {
  const businessId = getSelectedBusinessId();
  const portalToken = getPortalToken();

  return {
    ...headers,
    ...(businessId ? { 'X-Business-Id': businessId } : {}),
    ...(portalToken ? { Authorization: `Bearer ${portalToken}` } : {}),
  };
}

installSessionExpiredFetchWatcher();

function installSessionExpiredFetchWatcher() {
  if (
    hasInstalledSessionExpiredFetchWatcher ||
    typeof window === 'undefined' ||
    typeof window.fetch !== 'function'
  ) {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response && !response.ok && [401, 403].includes(response.status)) {
      notifySessionExpiredFromResponse(response);
    }

    return response;
  };

  hasInstalledSessionExpiredFetchWatcher = true;
}

async function notifySessionExpiredFromResponse(response) {
  let payload = null;

  try {
    payload = await response.clone().json();
  } catch (error) {
    payload = null;
  }

  const message = String(payload?.message || '').trim();

  if (!isPortalSessionExpiredMessage(message)) {
    return;
  }

  const now = Date.now();

  if (now - lastSessionExpiredNotificationAt < 1000) {
    return;
  }

  lastSessionExpiredNotificationAt = now;
  window.dispatchEvent(
    new CustomEvent(PORTAL_SESSION_EXPIRED_EVENT, {
      detail: { message: PORTAL_SESSION_EXPIRED_MESSAGE },
    })
  );
}

function isPortalSessionExpiredMessage(message) {
  const normalizedMessage = message.toLowerCase();

  return [
    PORTAL_SESSION_EXPIRED_MESSAGE,
    PORTAL_SESSION_INVALID_MESSAGE,
  ].some((sessionMessage) => normalizedMessage === sessionMessage.toLowerCase());
}
